import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Autocomplete } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom'; // <-- add this import
import { getReservationDetails } from '../../../service/network';
const StyledTextField = ({ label, align = 'left', placeholder, ...props }) => {
    const theme = useTheme();
    const inputBoxStyle = {
        "& .MuiOutlinedInput-root": {
            borderRadius: theme.borderRadius?.medium || 8,
            backgroundColor: theme.palette?.lightgray?.main || "#F3F4F6",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            "& fieldset": {
                borderColor: theme.palette?.gray?.main || "#D1D5DB",
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused": {
                backgroundColor: theme.palette?.light?.main || "#ffffff",
                "& fieldset": {
                    borderColor: theme.palette.primary.main,
                },
            },
            "& input": {
                textAlign: align,
            },
        },
    };

    return (
        <Box>
            {label && (
                <Typography variant="bodyText1" sx={{ mb: 0.5 }}>
                    {label}
                </Typography>
            )}
            <TextField
                size="small"
                fullWidth
                placeholder={placeholder}
                sx={inputBoxStyle}
                {...props}
            />
        </Box>
    );
};
const StyledAutocomplete = ({ label, options = [], ...props }) => {
    const theme = useTheme();
    const inputBoxStyle = {
        "& .MuiOutlinedInput-root": {
            borderRadius: theme.borderRadius?.medium || 8,
            backgroundColor: theme.palette?.lightgray?.main || "#F3F4F6",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            "& fieldset": {
                borderColor: theme.palette?.gray?.main || "#D1D5DB",
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused": {
                backgroundColor: theme.palette?.light?.main || "#ffffff",
                "& fieldset": {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
    };

    return (
        <Box>
            {label && (
                <Typography variant="bodyText1" sx={{ mb: 0.5 }}>
                    {label}
                </Typography>
            )}
            <Autocomplete
                options={options}
                renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth sx={inputBoxStyle} />
                )}
                {...props}
            />
        </Box>
    );
};

const OccupiedPopup = ({ onClose, onSave, room }) => {
    const navigate = useNavigate(); // <-- initialize navigate
    const [reservation, setReservation] = useState(null);
    const [housekeepingStatus, setHousekeepingStatus] = useState(room?.condition)
    console.log("roomdetails", room);
    const getReservationDls = async () => {
        try {
            let res_detail = await getReservationDetails(room.reservation);
            setReservation(res_detail.data.data);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if (room.reservation) {
            getReservationDls();
        }
    }, [room])
    const handleViewMore = () => {
        // You can pass a reservation ID as query or route param
        navigate(`/reservation`);
    };

    return (
        <Box
            sx={{

                p: 2.5,
                bgcolor: 'light.main',
                borderRadius: 2,
                boxShadow: 3,
                display: 'flex',
                flexDirection: 'column',
                maxWidth: "400px",
                gap: 2,
            }}
        >
            <Box display="flex" alignItems="center">
                <Typography>
                    Maintenance Issue : {room.maintenance_issues}
                </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="headingLarge" color='primary.main'>
                    {room?.reservation}
                </Typography>
                {/* <Button
                    onClick={handleViewMore}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        textTransform: 'none',
                        padding: 0,
                        minWidth: 'auto',
                    }}
                >
                    <Typography variant="subHeading" color="primary">
                        View More
                    </Typography>
                    <ArrowForwardIcon fontSize="small" />
                </Button> */}
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                <StyledTextField label="Room No." value={`${room.type}-${room.number}`} InputProps={{ readOnly: true }} />
                <StyledTextField label="Room Type" value={room.typeName} InputProps={{ readOnly: true }} />
            </Box>
            {reservation && <>
                <StyledTextField label="Guest Name" value={reservation?.primary_guest_name} />
                <StyledTextField label="Guest Mobile" value={reservation?.primary_guest_mobile} />
                <StyledTextField label="Guest Email" value={reservation?.primary_guest_email} /></>}

            <StyledAutocomplete
                label="Housekeeping Status"
                value={housekeepingStatus}
                options={["Dirty", "Clean", "Inspect", "Repair"]}
                onChange={(e, newValue) => setHousekeepingStatus(newValue)}
                defaultValue="Clean"
                fullWidth
                slotProps={{
                    paper: {
                        sx: {
                            '& .MuiAutocomplete-option:hover': {
                                backgroundColor: '#E1EFFF!important', // <-- custom hover color
                            },
                        },
                    },
                }}
            />


            <Box display="flex" justifyContent="end" mt={1} gap={1}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        borderRadius: 2, textTransform: 'none', border: '2px solid var(--Primary-Blue-MB, rgba(39, 57, 77, 1))',
                        minWidth: 126
                    }}
                >
                    Close
                </Button>
                <Button
                    variant="contained"
                    onClick={() => onSave(housekeepingStatus)}
                    sx={{ borderRadius: 2, textTransform: 'none', minWidth: 150 }}
                >
                    Save
                </Button>
            </Box>
        </Box>
    );
};

export default OccupiedPopup;